import { render } from "./SponsorshipPolicy.vue?vue&type=template&id=ec4bb4ea"
import script from "./SponsorshipPolicy.vue?vue&type=script&lang=js"
export * from "./SponsorshipPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__